const conf = require("../conf.json");
exports.callTableauApi = async ({ brand, email, id }) => {
  try {
    const response = await fetch(conf.api, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ brand, email, id }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    if (data.status) return data.data;
    throw new Error(`Invalid data: ${data}`);
  } catch (error) {
    console.error("Error:", error);
  }
};
